var React = require('react');

function CheckSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.302 3.312l-6.306 7.002-2.298-2.551a.951.951 0 00-.705-.312.955.955 0 00-.7.326A1.177 1.177 0 002 8.554c-.002.291.099.572.281.782l3.006 3.338a.954.954 0 00.709.326c.266 0 .52-.117.708-.326l7.015-7.788c.182-.21.283-.491.281-.783a1.177 1.177 0 00-.293-.777.955.955 0 00-.7-.326.952.952 0 00-.705.312z"}));
}

CheckSmall.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckSmall;

CheckSmall.default = CheckSmall;
